import { Box } from "@vapor/react-material";
import Typography from "@vapor/react-extended/ExtendedTypography";

export const BusinessGrown = () => (
    <Box
        sx={{
            maxWidth: "454px",
        }}
    >
        <Typography
            variant="bodyLarge"
            color="#5a6872"
        >
            I servizi TS Digital ti aiutano ad elevare il tuo business e a rimanere costantemente
            aggiornato sulle nuove normative.
        </Typography>
    </Box>
);
